<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="rucontent flx alc jsc">
           登录中，请稍后...
        </div>
    </div>
</template>

<script>
    import {
        getWechat
    } from "@/api/index.js"
    export default {
        name: 'getCode',
        data() {
            return {
                info: {}
            }
        },
        created() {
            let that = this
            let code = this.$route.query.code
            let data = {}
            data.code = code
            getWechat(data).then((res) => {
                if(res.code == 1){
                    that.$message.success(res.msg)
                    localStorage.setItem('token', res.data.token)
                    localStorage.setItem('user_id', res.data.user_id)
                    window.location.href = "https://hrxsl.com/"
                }else{
                    that.$message.error(res.msg)
                }
            })
        },
        methods: {

        }
    }
</script>

<style scoped>
    .qrdes {
        margin-top: 8px;
        font-size: 13px;
        color: #4A4A4A;
    }

    .qrPart {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .qrname {
        font-weight: 600;
        font-size: 17px;
        color: #222222;
        text-align: center;
    }

    .qrImage {
        width: 126px;
        height: 130px;
        margin-bottom: 12px;
    }

    .qrImage img {
        width: 100%;
        height: 100%;
    }

    .svIcon {
        width: 54px;
        height: 54px;
    }

    .svWord {
        font-weight: 600;
        font-size: 28px;
        margin-left: 16px;
        margin-right: 235px;
    }

    .svIcon img {
        width: 100%;
        height: 100%;
    }

    .rucontent {
        box-sizing: border-box;
        padding: 0 100px;
        background: #fff;
        width: 1460px;
        height: 280px;
        margin: 0 auto;
        text-align: center;
    }
</style>